import type { Agreement, AgreementPayment } from '@/types/database';

export type { Agreement, AgreementPayment };

export const ALLOWED_PAYMENT_FILE_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/webp',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
  'text/plain',
];

export const MAX_PAYMENT_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_PAYMENT_FILE_SIZE_LABEL = '10MB';

export interface AgreementSummary {
  agreementId: string;
  paymentsCount: number;
  totalGross: number;
  totalGlosa: number;
  totalNet: number;
  lastPaymentDate: string | null;
}
